(function () {
    'use strict';

    angular.module('UndergroundWebApp').controller('AdministrationController', AdministrationController);

    AdministrationController.$inject = [
        '$scope',
        '$rootScope',
        '$state',
        'authService',
        'tabstripUtility',
        '$translate'
    ];

    function AdministrationController(
        $scope,
        $rootScope,
        $state,
        authService,
        tabstripUtility,
        $translate
    ) {
        var busyIndicatorCounter = 0;

        $scope.showBusyIndicator = showBusyIndicator;
        $scope.hideBusyIndicator = hideBusyIndicator;

        $scope.tabStripOptions = {
            animation: false,
            select: tabstripUtility.handleTabSelected,
            dataTextField: 'name',
            dataContentUrlField: 'contentUrl',
            dataSource: {
                transport: {
                    read: getTabs
                }
            },
            dataBound: (e) => e.sender.select(0),
        };

        initController();

        function initController() {
            $scope.$watch(() => $state.current.name, (state) => {
                tabstripUtility.changeTabByState($scope.administrationtab, state);
            });

            authService.getAccessRights().then(() => {
                $scope.administrationtab.dataSource.data(getTabs());
                tabstripUtility.changeTabByState($scope.administrationtab, $state.current.name);
            }).catch((err) => {
                console.log(err);
            });
        };

        function showBusyIndicator() {
            if (busyIndicatorCounter === 0) {
                $rootScope.$broadcast('showBusyIndicator', {
                    id: 'adminIndicator',
                    destination: '.administration',
                    message: $translate.instant('G_BUSY_INDICATOR'),
                    overlay: true,
                    positionClass: {
                        top: '50%',
                        left: '0px',
                        right: '0px'
                    }
                });
            }

            busyIndicatorCounter += 1;
        }

        function hideBusyIndicator() {
            busyIndicatorCounter -= 1;

            if (busyIndicatorCounter === 0) {
                $rootScope.$broadcast('hideBusyIndicator', 'adminIndicator');
            }
        }

        function getTabs() {
            const tabs = [];

            if ($rootScope.isVisible('CORE', { Area: 'NewFraction', AccessType: 'R' })) {
                tabs.push({
                    name: $translate.instant('ADMINISTRATION_FRACTION_FRACTIONS'),
                    contentUrl: 'app/administration/fraction/fractions-view.html',
                    state: 'main.administration.fractions',
                });
            }
            if ($rootScope.isVisible('CORE', { Area: 'NewContainerType', AccessType: 'R' })) {
                tabs.push({
                    name: $translate.instant('ADMINISTRATION_CONTAINERTYPES'),
                    contentUrl: 'app/administration/containerType/container-types-view.html',
                    state: 'main.administration.containerTypes',
                });
            }
            if ($rootScope.isVisible('CORE', { Area: 'ContainerItemType', AccessType: 'R' })) {
                tabs.push({
                    name: $translate.instant('ADMINISTRATION_CONTAINERITEMTYPES'),
                    contentUrl: 'app/administration/containerItemType/container-item-types-view.html',
                    state: 'main.administration.containerItemTypes',
                });
            }
            if ($rootScope.isVisible('CORE', { Area: 'Vehicle', AccessType: 'R' })) {
                tabs.push({
                    name: $translate.instant('ADMINISTRATION_VEHICLE_VEHICLES'),
                    contentUrl: 'app/administration/vehicle/vehicles-view.html',
                    state: 'main.administration.vehicles',
                });
            }
            if ($rootScope.isVisible('CORE', { Area: 'ExternalLink', AccessType: 'R' })) {
                tabs.push({
                    name: $translate.instant('ADMINISTRATION_EXTERNAL_LINKS'),
                    contentUrl: 'app/administration/externalLinks/external-links-view.html',
                    state: 'main.administration.externalLinks',
                });
            }
            if ($rootScope.isVisible('CORE', { Area: 'UserAdmin', AccessType: 'R' })) {
                tabs.push({
                    name: $translate.instant('ADMINISTRATION_MUNICIPALITY_MUNICIPALITIES'),
                    contentUrl: 'app/administration/municipality/municipalities-view.html',
                    state: 'main.administration.municipalities',
                });
            }
            if ($rootScope.isVisible('CORE', { Area: 'UserAdmin', AccessType: 'R' })) {
                tabs.push({
                    name: $translate.instant('ADMINISTRATION_USERS'),
                    contentUrl: 'app/administration/user/user-administration-view.html',
                    state: 'main.administration.userAdministration',
                });
            }
            if ($rootScope.isVisible('CORE', { Area: 'ClientId', AccessType: 'R' })) {
                tabs.push({
                    name: $translate.instant('ADMINISTRATION_CLIENT_CLIENTS'),
                    contentUrl: 'app/administration/clients/clients-view.html',
                    state: 'main.administration.clients',
                });
            }
            if ($rootScope.isVisible('CORE', { Area: 'NewFraction', AccessType: 'R' })) {   //$rootScope.isVisible('CORE', { Area: 'NewDeviationAlert', AccessType: 'R' })
                tabs.push({
                    name: $translate.instant('ADMINISTRATION_DEVIATION_JOBS'),
                    contentUrl: 'app/administration/deviationReport/deviation-report-view.html',
                    state: 'main.administration.deviationAlert',
                });
            }
            if ($rootScope.isVisible('CORE', { Area: 'UserAdmin', AccessType: 'R' })) {
                tabs.push({
                    name: $translate.instant('ADMINISTRATION_LOG_ACTIONS_LOG_ACTIONS'),
                    contentUrl: 'app/administration/logAction/logActions-view.html',
                    state: 'main.administration.logActions',
                });
                // tabs.push({
                //     name: $translate.instant('ADMINISTRATION_BATTERY_TYPE'),
                //     contentUrl: 'app/administration/batteryType/battery-type-view.html',
                //     state: 'main.administration.batteryTypes',
                // });
            }

            return tabs;
        }
    }
})();
